module.exports = __webpack_public_path__ + "img/open.c5370780.png";